import { Alpine } from 'alpinejs';
import "../css/styles.scss";

// Alpine JS Modules
import { SiteHeader } from "./components/global/site-header";

// Vanilla JS Modules
import renderLabels from "./utils/componentLabels";
import menuToggle from "./layout/menuToggle";
import mobileNavigation from "./layout/navigation";
import accordions from "./components/blocks/accordions";
import webinars from "./components/banners/webinar";
import faqSections from "./components/blocks/faqSections";
import testimonials from "./components/blocks/testimonial";
import heroBanner from "./components/banners/heroBanner";
import slideshowRow from "./components/rows/slideshow-row";
import carouselRow from "./components/rows/carousel-row";
import logosRow from "./components/rows/logos-row";
import videoBlock from "./components/content-blocks/video-block";

if (import.meta.env.MODE === 'development') {
  renderLabels();
}

const init = () => {
  menuToggle();
  mobileNavigation();
  accordions();
  // webinars();
  faqSections();
  testimonials();
	heroBanner();
	slideshowRow();
	carouselRow();
	logosRow();
	videoBlock();
}
//console.log(import.meta.env.MODE)

window.addEventListener("load", () => {
  document.querySelector('body').classList.remove('preload');
  init();
}, false);

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR")
  });
}

// Alpine components
Alpine.data('SiteHeader', SiteHeader);

// Add Alpine to the window and start
window.Alpine = Alpine;
Alpine.start();
